import React, { useState } from "react";
import { Link, Redirect, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
// @material-ui/core components
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  TextField,
  CircularProgress,
  IconButton,
  Icon,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
// @material-ui/styles
import styles from "../../../../../assets/jss/layouts/appStyle";
import { makeStyles } from "@material-ui/core/styles";
// core components
import { LOCALE } from "../../../../../properties/Locale";
import EntityMetadata from "../../../../../common/components/EntityMetadata";
import {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
  triggerRerender,
} from "../../../../../common/actions/CommonActions";
import Card from "../../../../../common/components/Card/Card.js";
import CardHeader from "../../../../../common/components/Card/CardHeader.js";
import CardBody from "../../../../../common/components/Card/CardBody.js";
import { EducationalRoleRepository } from "./EducationalRoleRepository";
import { validateCreateForm } from "../../Validations";

const useStyles = makeStyles(styles);

export default function EducationalRoleCreateComponent(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [redirectTo, setRedirectTo] = useState();
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const {
    handleSubmit: createRoleForm,
    register: registerCreateForm,
    errors: errorsCreateRole,
    getValues,
  } = useForm({ validationSchema: validateCreateForm });
  const dispatch = useDispatch();
  let { gradingSchemaId } = useParams();

  const showLoadingBar = () => {
    setLoading(true);
    setBtnSubmitLoading(true);
  };

  const hideLoadingBar = () => {
    setLoading(false);
    setBtnSubmitLoading(false);
  };

  const handleSubmit = (values) => {
    showLoadingBar();
    const payload = {
      ...values,
      gradingSchemaId: gradingSchemaId,
    };
    EducationalRoleRepository.create(payload)
      .then((res) => {
        hideLoadingBar();
        dispatch(triggerRerender());
        dispatch(
          notifyShowSuccessMessage(LOCALE.training_role_create_success_message)
        );
        setRedirectTo(
          `/app/configuration/gradingSchema/${gradingSchemaId}/edit`
        );
      })
      .catch((err) => {
        hideLoadingBar();
        dispatch(notifyShowErrorMessage(err.message));
      });
  };

  const handleClose = () => {};
  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <Card>
        <Dialog
          open={true}
          onClose={handleClose}
          maxWidth="md"
          fullWidth={true}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>
              {`${LOCALE.create_new_training_role}`}
              <Link
                to={`/app/configuration/gradingSchema/${gradingSchemaId}/edit`}
                style={{ textDecoration: "none" }}
              >
                <IconButton
                  style={{ float: "right", color: "white" }}
                  aria-label="close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Link>
            </h4>
          </CardHeader>
          <CardBody>
            {loading ? <LinearProgress color="secondary" /> : ""}
            <div>
              <form onSubmit={createRoleForm(handleSubmit)}>
                <DialogContent>
                  <TextField
                    id="name"
                    label={LOCALE.name}
                    error={errorsCreateRole?.name}
                    helperText={errorsCreateRole?.name?.message}
                    size="small"
                    fullWidth={true}
                    margin="normal"
                    variant="outlined"
                    name="name"
                    inputRef={registerCreateForm}
                    InputProps={{
                      disabled: btnSubmitLoading,
                    }}
                  />
                  <FormControlLabel
                    control={<Checkbox name="active" color="primary" />}
                    label={LOCALE.active}
                    size="small"
                    inputRef={registerCreateForm}
                  />

                  <EntityMetadata data={getValues()} />
                </DialogContent>
                <DialogActions>
                  {!btnSubmitLoading && (
                    <Link
                      to={`/app/configuration/gradingSchema/${gradingSchemaId}/edit`}
                      style={{ textDecoration: "none" }}
                    >
                      <Button size="small" variant="outlined" color="secondary">
                        {LOCALE.cancel}
                      </Button>
                    </Link>
                  )}
                  <Button
                    type="submit"
                    size="small"
                    variant="contained"
                    disabled={btnSubmitLoading}
                    className={btnSubmitLoading ? "btn-loading" : ""}
                    color="primary"
                  >
                    {LOCALE.save}
                    {btnSubmitLoading && (
                      <CircularProgress
                        color="secondary"
                        size={20}
                        style={{ position: "absolute" }}
                      />
                    )}
                  </Button>
                </DialogActions>
              </form>
            </div>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
